import React, { Suspense, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useUser from '../../Hooks/useUser.js';
import Loading from '../Loading/index.js';

const PageNotFound = React.lazy(() => import('../../Pages/PageNotFound/index.js'));

const userPage = {
  tools: React.lazy(() => import('../../Pages/User/tools/index.js')),
  'tools/[id]': React.lazy(() => import('../../Pages/User/tools/[id].js')),
  credits: React.lazy(() => import('../../Pages/User/credits/index.js')),
  library: React.lazy(() => import('../../Pages/User/library/index.js')),
  contact: React.lazy(() => import('../../Pages/User/contact-us/index.js')),
  faq: React.lazy(() => import('../../Pages/User/faq/index.js')),
  'library/[id]': React.lazy(() => import('../../Pages/User/library/[id].js')),
  notebooks: React.lazy(() => import('../../Pages/User/notebooks/index.js')),
  memberships: React.lazy(() => import('../../Pages/User/memberships/index.js')),
  donations: React.lazy(() => import('../../Pages/User/donations/index.jsx')),
  // orders: React.lazy(() => import('../../Pages/User/recent-purchases')),
  // 'orders/[id]': React.lazy(() => import('../../Pages/User/recent-purchases/[id]')),
  'profile/[id]': React.lazy(() => import('../../Pages/User/profile/[id].js')),
  'order-history': React.lazy(() => import('../../Pages/User/order-history/index.jsx')),
  'order-history/[id]': React.lazy(() => import('../../Pages/User/order-history/[id].jsx'))
  // cart: React.lazy(() => import('../../Pages/User/cart')),
  // shop: React.lazy(() => import('../../Pages/User/products')),
  // 'shop/[id]': React.lazy(() => import('../../Pages/User/products/[id]'))
};

const adminPage = {
  tools: React.lazy(() => import('../../Pages/Admin/tools/index.js')),
  'tools/create': React.lazy(() => import('../../Pages/Admin/tools/create.js')),
  'tools/[id]': React.lazy(() => import('../../Pages/Admin/tools/[id].js')),
  users: React.lazy(() => import('../../Pages/Admin/users/index.js')),
  'users/[id]': React.lazy(() => import('../../Pages/Admin/users/[id].jsx')),
  disclaimers: React.lazy(() => import('../../Pages/Admin/disclaimers/index.js')),
  'profile/[id]': React.lazy(() => import('../../Pages/User/profile/[id].js')),
  contact: React.lazy(() => import('../../Pages/User/contact-us/index.js')),
  faq: React.lazy(() => import('../../Pages/User/faq/index.js')),
  'order-history': React.lazy(() => import('../../Pages/User/order-history/index.jsx')),
  'order-history/[id]': React.lazy(() => import('../../Pages/User/order-history/[id].jsx')),

  churches: React.lazy(() => import('../../Pages/Admin/churches/index.js')),
  'churches/create': React.lazy(() => import('../../Pages/Admin/churches/create/index.js')),
  'churches/[id]': React.lazy(() => import('../../Pages/Admin/churches/[id].js')),
  'site-settings': React.lazy(() => import('../../Pages/Admin/siteSettings/index.js'))
};

const PageRender = () => {
  const { page, id } = useParams();

  const { currentUser: user, userView } = useUser();

  let pageName = '';

  if (user) {
    if (id) {
      if (id === 'create') {
        pageName = `${page}/create`;
      } else if (id === 'join') {
        pageName = `${page}/join`;
      } else {
        pageName = `${page}/[id]`;
      }
    } else {
      pageName = `${page}`;
    }
  }

  const usePage = useMemo(() => {
    switch (true) {
      case user?.role === 'admin' && !userView:
        return adminPage;
      case user?.role === 'admin' && userView:
      case user?.role === 'user' && userView:
      case userView:
      default:
        return userPage;
    }
  }, [user?.role, userView]);

  const Page = usePage[pageName] || PageNotFound;

  return (
    <Suspense fallback={<Loading />}>
      <Page />
    </Suspense>
  );
};

export default PageRender;
